module.exports = __webpack_public_path__ + "static/media/HOMEPAGE_1.8e0bb777.jpg";